import React, { useEffect, useState} from 'react';
import customCSS from './Myplants.module.css'
import ENV from '../../constants/env-constants';
import { useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { formatNumbers } from '../../utils/formatNumbers';

function MySubscriptions() {
  
  const userid = localStorage.getItem('userid');
  const [transactions, setTransactions] = useState([]);
  const location = useLocation();

  const fetchTransactions = async () => {
    const response = await fetch(`${ENV.API_URL}/api/subscriptionlist/${userid}`);
    const data = await response.json();
    console.log(data)
    setTransactions(data);
  };
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Dashboard MySubscriptions Page' });

    fetchTransactions();
  }, []);
  
  async function cancelSubscription(subscriptionId) {
    const response = await fetch(`${ENV.API_URL}/api/subscription/cancel/${subscriptionId}`, {
      method: 'get'
    });
    fetchTransactions();
  }
  return (
    <>
    <div className="layout-wrapper layout-content-navbar">
      <Helmet>
        <meta charSet="utf-8" />
        <title>My Subscriptions</title>
      </Helmet>
      <div className={`layout-container ${customCSS.maincontainer}`}>
          <h1 className={customCSS.heading}>My Subscriptions</h1>

          <div className={customCSS.layoutWrapper}>
            <div className={customCSS.layoutContainer}>
              <div className={customCSS.tableWrapper}>
              <table className={customCSS.table}>
                <thead>
                  <tr>
                    <th className={customCSS.th}>Subscription ID</th>
                    <th className={customCSS.th}>Time Stamp</th>
                    <th className={customCSS.th}>Card Number</th>
                    <th className={customCSS.th}>Amount</th>
                    <th className={customCSS.th}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {/* filter is added to remove transactions with 0 dollars. */}
                  {/* Why 0 dollars transaction exists? Ans: These are generally added in transactions to add free trees recievers, even though they haven't spend money but the tree is planted on their behalf so it will be like 1 tree for 0 dollars */}
                  {transactions.filter((transaction) => Boolean(transaction.amount)).map((transaction, index) => (
                    <tr key={index}>
                      <td className={customCSS.td}>{transaction.id}</td>
                      <td className={customCSS.td}>{transaction.createTimeStampUTC}</td>
                      <td className={customCSS.td}>{transaction.accountNumber}</td>
                      <td className={customCSS.td}>{transaction.amount}</td>
                      <td className={customCSS.td}><button style={{backgroundColor: "#ff3636", borderRadius: "0.3rem", border: 0, color: "white", padding: '0.4rem'}} onClick={()=> cancelSubscription(transaction.id)}>Cancel</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </div>
          </div>
      </div>
    </div>
    </>
  );
}

export default MySubscriptions;